<template>
  <div class="wrapper">
    <div class="w-full flex items-center justify-center">
      <div class="card flex flex-col bg-white rounded max-w-sm w-full">
        <div class="w-full flex justify-between items-center pb-8">
          <h3 class="nxp-section-title">
            Informe sua experiência
          </h3>
          <div @click="closePage" class="closeBtn">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <path
                d="M15.5187 4.83176C15.4416 4.75451 15.3501 4.69322 15.2493 4.6514C15.1484 4.60958 15.0404 4.58806 14.9312 4.58806C14.8221 4.58806 14.714 4.60958 14.6132 4.6514C14.5124 4.69322 14.4208 4.75451 14.3437 4.83176L10.2687 8.89843L6.19374 4.82343C6.11659 4.74628 6.025 4.68508 5.92419 4.64332C5.82339 4.60157 5.71535 4.58008 5.60624 4.58008C5.49713 4.58008 5.38909 4.60157 5.28829 4.64332C5.18748 4.68508 5.09589 4.74628 5.01874 4.82343C4.94159 4.90058 4.88039 4.99217 4.83864 5.09298C4.79688 5.19378 4.77539 5.30182 4.77539 5.41093C4.77539 5.52004 4.79688 5.62808 4.83864 5.72888C4.88039 5.82968 4.94159 5.92128 5.01874 5.99843L9.09374 10.0734L5.01874 14.1484C4.94159 14.2256 4.88039 14.3172 4.83864 14.418C4.79688 14.5188 4.77539 14.6268 4.77539 14.7359C4.77539 14.845 4.79688 14.9531 4.83864 15.0539C4.88039 15.1547 4.94159 15.2463 5.01874 15.3234C5.09589 15.4006 5.18748 15.4618 5.28829 15.5035C5.38909 15.5453 5.49713 15.5668 5.60624 15.5668C5.71535 15.5668 5.82339 15.5453 5.92419 15.5035C6.025 15.4618 6.11659 15.4006 6.19374 15.3234L10.2687 11.2484L14.3437 15.3234C14.4209 15.4006 14.5125 15.4618 14.6133 15.5035C14.7141 15.5453 14.8221 15.5668 14.9312 15.5668C15.0403 15.5668 15.1484 15.5453 15.2492 15.5035C15.35 15.4618 15.4416 15.4006 15.5187 15.3234C15.5959 15.2463 15.6571 15.1547 15.6988 15.0539C15.7406 14.9531 15.7621 14.845 15.7621 14.7359C15.7621 14.6268 15.7406 14.5188 15.6988 14.418C15.6571 14.3172 15.5959 14.2256 15.5187 14.1484L11.4437 10.0734L15.5187 5.99843C15.8354 5.68176 15.8354 5.14843 15.5187 4.83176Z"
                fill="#696969" />
            </svg>
          </div>
        </div>

        <ValidationObserver class="w-full" ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="submit()">
          <div class="w-full flex flex-col space-y-4 mt-8">

            <ValidationProvider rules="required" name="empresa" v-slot="{ errors }">
              <div class="w-full flex flex-col space-y-4">
                <label for="company" class="nxp-label">Empresa</label>
                <vs-input id="company" class="w-full no-icon-border mb-1" v-model="payload.company" type="text"
                  :danger="errors.length > 0" />
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" name="cargo" v-slot="{ errors }">
              <div class="w-full flex flex-col space-y-4">
                <label for="business_role" class="nxp-label">Cargo</label>
                <vs-input id="business_role" class="w-full no-icon-border mb-1" v-model="payload.business_role"
                  type="text" :danger="errors.length > 0" />

                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </div>
            </ValidationProvider>

            <div class="w-full flex flex-col space-y-6">
              <label for="is_current" class="nxp-checkbox-container">
                <vs-checkbox id="is_current" class="mb-1" color="primary" v-model="payload.is_current" />
                <p>
                  É meu emprego Atual
                </p>
              </label>
            </div>

            <div class="w-full flex flex-row space-x-4">
              <ValidationProvider rules="required|monthYear" name="data_inicio" v-slot="{ errors }" mode="lazy">
                <div class="w-full flex flex-col space-y-4">
                  <label for="from_date" class="nxp-label">Data de início</label>
                  <span class="nxp-sublabel">
                    Mês e ano (Ex:. 01/2006)
                  </span>
                  <vs-input id="from_date" class="w-full no-icon-border mb-1" type="text" placeholder="___/_____"
                    v-mask="'##/####'" v-model="payload.from_date" :danger="errors.length > 0" />
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </div>
              </ValidationProvider>

              <ValidationProvider :rules="payload.is_current ? '' : 'required|monthYear'" name="data_saida"
                v-slot="{ errors }" vid="confirmation" mode="lazy">
                <div class="w-full flex flex-col space-y-4">
                  <label for="is_current" class="nxp-label">
                    {{ payload.is_current ? 'Data de saída' : 'Data de saída' }}
                  </label>
                  <span class="nxp-sublabel">
                    Mês e ano (Ex:. 01/2006)
                  </span>
                  <vs-input id="is_current" class="w-full no-icon-border mb-1" type="text"
                    :placeholder="payload.is_current ? 'É meu emprego Atual' : '___/_____'" v-mask="'##/####'"
                    :disabled="payload.is_current" v-model="payload.to_date" :danger="errors.length > 0" />
                  <span class="text-danger">
                    {{ errors[0] }}
                  </span>
                </div>
              </ValidationProvider>
            </div>

            <div class="w-full flex flex-col space-y-4">
              <label for="description" class="nxp-label">
                Descrição
              </label>
              <vs-textarea id="description" class="w-full no-icon-border my-8" v-model="payload.description" rows="5"
                name="description" type="text" />
            </div>


            <div class="w-full h-6">

            </div>

            <button :disabled="invalid" :style="{ background: color }" class="nxp-continue-btn" type="submit">
              Salvar
            </button>

          </div>
        </ValidationObserver>

      </div>
    </div>
  </div>
</template>

<script>
import { isBefore, format, formatDistanceStrict } from "date-fns";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ptBR from "date-fns/locale/pt-BR";

export default {
  props: ["experience"],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    payload: {
      skills: [],
      index: 0,
      to_date: "",
      period: "",
      company: "",
      from_date: "",
      description: "",
      is_current: false,
      popupActive: false,
      business_role: "",
    },
    skills: "",
  }),
  watch: {
    "payload.is_current": function () {
      if (this.payload.is_current) {
        this.payload = {
          ...this.payload,
          to_date: null,
        };
      }
    },
  },
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      this.$vs.loading({ text: "Enviando... " });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=experiences`, {
          experiences: [
            {
              ...this.payload,
              to_date: this.payload.is_current ? null : "01/".concat(this.payload.to_date),
              from_date: "01/".concat(this.payload.from_date),
              period: this.payload.is_current
                ? this.formatPeriodlWithis_current()
                : this.formatPeriodWithoutis_current(),
            },
          ],
        })
        .then((response) => {
          this.$vs.loading.close();

          if (this.payload.id) {
            this.$store.dispatch("experience/update", {
              ...this.payload,
            });
          } else {
            this.$store.dispatch("experience/store", {
              ...this.payload,
              id: response.data.data.experiences[0].id,
            });
            // PostHog: experience_added
            (async () => {
              try {
                const { trackEvent } = await import("@/services/posthog");
                trackEvent("experience_added", {
                  company: this.payload.company,
                  business_role: this.payload.business_role,
                  period: this.payload.period,
                  from_date: this.payload.from_date,
                  to_date: this.payload.to_date,
                });
              } catch (_) {}
            })();
          }

          this.$router.back();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    closePage() {
      this.$router.back();
    },
    handleRemoveSkill: function (skill) {
      let skills = [...this.payload.skills];

      this.payload = {
        ...this.payload,
        skills: skills.filter((sk) => sk !== skill),
      };
    },
    handleAddSkill: function () {
      const _skills = this.skills.split(",").filter((skill) => skill != "");

      this.payload = {
        ...this.payload,
        skills: [...this.payload.skills, ..._skills],
      };
    },
    setCurrentDate() {
      const split = format(new Date(), "MM/dd/yyyy").split("/");

      return `${split[0]}/${split[2]}`;
    },
    formatPeriodWithoutis_current() {
      const { from_date, to_date } = this.payload;
      const splitFrom = "01/".concat(from_date).split("/");
      const splitTo = "01/".concat(to_date).split("/");
      const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
      const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

      return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true });
    },
    formatPeriodlWithis_current() {
      const { from_date } = this.payload;
      const splitFrom = "01/".concat(from_date).split("/");

      const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
      const to = new Date();

      return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true });
    },
  },
  created() {
    this.$validator.extend(
      "monthYear",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique a data informada",
        validate: (value) =>
          new Promise((resolve) => {
            if (parseInt(value.split("/")[0]) > 12)
              resolve({
                valid: false,
                data: {
                  message: `O mês ${value.split("/")[0]
                    } informado não é válido!`,
                },
              });
            else
              resolve({
                valid: true,
                data: { message: "" },
              });
          }),
      },
      { hasTarget: true, immediate: false }
    );

    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: (value) => {
          return new Promise((resolve) => {
            if (!this.payload.is_current) {
              if (this.payload.from_date == "")
                resolve({
                  valid: false,
                  data: { message: "A data de início está vazia!" },
                });

              const splitFrom = "01/".concat(this.payload.from_date).split("/");
              const splitTo = "01/".concat(value).split("/");

              const monthReg = /0[1-9]|1[0-2]/;
              const yearReg = /(?:(?:19|20)[0-9]{2})/;

              if (!splitFrom[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitFrom[1]} informado na data de início não é válido!`,
                  },
                });
              if (!splitTo[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitTo[1]} informado não é válido!`,
                  },
                });

              if (!splitFrom[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitFrom[2]} informado na data de início não é válido!`,
                  },
                });
              if (!splitTo[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitTo[2]} informado não é válido!`,
                  },
                });

              const from = new Date(
                splitFrom[2],
                splitFrom[1] - 1,
                splitFrom[0]
              );
              const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

              resolve({
                valid: isBefore(from, to),
                data: {
                  message: `${isBefore(from, to)
                    ? ""
                    : "A data de finalização não pode ser menor que a data de início"
                    }`,
                },
              });
            }
          });
        },
      },
      { hasTarget: true, immediate: false }
    );

    if (this.experience) {
      this.payload = {
        ...this.experience,
        is_current: !!this.experience.is_current,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>
